module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av37-2c29422b645703f5290c625bf98a7ef2.jpg";